import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthService from '../SDA/AuthService';
import { getEnvConfig } from './getEnv';

const env = getEnvConfig();

const timeOut = Number(env.SESSION_TIMEOUT) * 60 * 1000;

const SessionManager = ({ children }) => {
  const navigate = useNavigate();
  let sessionTimeout = null;
  const startSessionTimeout = () => {
    if (sessionTimeout) clearTimeout(sessionTimeout);
    sessionTimeout = setTimeout(() => {
      handleSessionTimeout();
    }, timeOut);
  };

  const resetTimers = () => {
    clearTimeout(sessionTimeout);
    startSessionTimeout();
  };

  const handleSessionTimeout = async () => {
    try {
      await AuthService.clearSession();
      clearTimeout(sessionTimeout);
      navigate('/session-timeout');
    } catch (error) {
      console.error('Session timeout handling failed', error);
      navigate('/error');
    }
  };

  useEffect(() => {
    startSessionTimeout();
    const events = ['keydown', 'click']; //, 'mousemove'
    events.forEach((event) => {
      window.addEventListener(event, resetTimers);
    });

    // Clean up event listeners and timers on unmount
    return () => {
      events.forEach((event) => {
        window.removeEventListener(event, resetTimers);
      });
      clearTimeout(sessionTimeout);
    };
  }, []);

  return <>{children}</>;
};

export default SessionManager;
